import React from 'react';

import { Box, Typography, CircularProgress } from '@material-ui/core';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import BeginDevolutionForm from './components/BeginDevolutionForm';
import {
  MainContainer,
  MainContainerTitle,
  CustomButton,
  CustomSeparator,
} from '../../styles';
import { MainContainerFormBody, CustomBackButtonBox } from './styles';
import usePageStore from '../../../../store/pageStore';
import useConfigsStore from '../../../../store/configsStore';
import { dateFormat } from '../../../../../../core/utils/dateFormat';

export default function DevolutionFormStep({
  queryParametersData,
  showAddressFields,
  handleFormSubmit,
  hideOrderNumberField,
  hideEmailField,
  disableUrlCompletedFields,
}) {
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  const storeConfigs = useConfigsStore((state) => state.storeConfigs);
  const showClientCreationForm = usePageStore(
    (state) => state.showClientCreationForm,
  );
  const setShowClientCreationForm = usePageStore(
    (state) => state.setShowClientCreationForm,
  );
  const isOrderBeingCreated = usePageStore(
    (state) => state.isOrderBeingCreated,
  );
  const memphisOrderInfo = usePageStore((state) => state.memphisOrderInfo);

  const primaryColor = devolutionPageConfigs?.primaryColor || '#000000';
  const secondaryColor = devolutionPageConfigs?.secondaryColor || '#ffffff';
  const fontColor = devolutionPageConfigs?.fontColor || '#000000';
  const fontColorSecondary =
    devolutionPageConfigs?.fontColorSecondary || '#000000';
  const fontFamily =
    devolutionPageConfigs?.fontFamily || 'helvetica, sans-serif';
  return (
    <MainContainer backgroundcolor={secondaryColor}>
      <MainContainerTitle padding="0px">
        {showClientCreationForm && (
          <CustomBackButtonBox>
            <ChevronLeftIcon
              onClick={() => setShowClientCreationForm(false)}
              sx={{ cursor: 'pointer' }}
            />
          </CustomBackButtonBox>
        )}
        <Typography variant="h5">
          <Box
            sx={{
              fontWeight: 'bold',
              color: fontColor,
              fontFamily,
            }}
          >
            {storeConfigs?.enableMemphisOrderInfoSearch &&
            memphisOrderInfo &&
            showClientCreationForm
              ? 'Verifique suas informações'
              : 'Comece sua devolução'}
          </Box>
        </Typography>
        <CustomSeparator />
        <Typography style={{ color: fontColor, fontFamily }}>
          {storeConfigs?.enableMemphisOrderInfoSearch &&
          memphisOrderInfo &&
          showClientCreationForm
            ? 'Certifique que todas as informações estão corretas para começar sua devolução.'
            : 'Entre com as informações solicitadas para começar a devolução.'}
        </Typography>
      </MainContainerTitle>
      <MainContainerFormBody>
        <BeginDevolutionForm
          queryParametersData={queryParametersData}
          showAddressFields={showAddressFields}
          onFormSubmit={handleFormSubmit}
          hideOrderNumberField={hideOrderNumberField}
          hideEmailField={hideEmailField}
          disableUrlCompletedFields={disableUrlCompletedFields}
        />
      </MainContainerFormBody>
      {storeConfigs?.enableMemphisOrderInfoSearch &&
        memphisOrderInfo &&
        showClientCreationForm && (
          <Typography
            style={{
              color: fontColor,
              fontFamily,
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '20px',
            }}
          >
            Sua devolução deve ser feita até{' '}
            {dateFormat(memphisOrderInfo?.expirationDate)}.
          </Typography>
        )}
      <CustomButton type="submit" form="order-creation" color={primaryColor}>
        {isOrderBeingCreated ? (
          <CircularProgress style={{ color: fontColorSecondary }} />
        ) : (
          <Typography style={{ color: fontColorSecondary, fontFamily }}>
            Avançar
          </Typography>
        )}
      </CustomButton>
    </MainContainer>
  );
}
